module.exports = __webpack_public_path__ + "assets/img/移动.2b712a48.jpg";